import React from "react";

import Typography from "@mui/material/Typography";

import { ReactComponent as EmptyBlockIcon } from "assets/images/empty-block-icon.svg";

import "./index.scss";

interface EmptyBlockProps {
  text?: string;
}

const EmptyBlock: React.FC<EmptyBlockProps> = ({ text }) => {
  return (
    <div className="empty-block">
      <EmptyBlockIcon />
      <div className="empty-text-wrapper">
        <Typography
          variant="body1"
          color="grey700"
          textAlign="center"
          sx={{ whiteSpace: "pre-line" }}
        >
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default EmptyBlock;
